var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGraph(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#2D9BF0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6001 14.4004H19.6001V44.4004H49.6001V46.4004H17.6001V14.4004ZM37.6001 21.4004C37.6001 21.1352 37.7055 20.8808 37.893 20.6933C38.0805 20.5057 38.3349 20.4004 38.6001 20.4004H46.6001C46.8653 20.4004 47.1197 20.5057 47.3072 20.6933C47.4947 20.8808 47.6001 21.1352 47.6001 21.4004V29.4004C47.6001 29.6656 47.4947 29.92 47.3072 30.1075C47.1197 30.295 46.8653 30.4004 46.6001 30.4004C46.3349 30.4004 46.0805 30.295 45.893 30.1075C45.7055 29.92 45.6001 29.6656 45.6001 29.4004V24.2004L38.3741 33.0344C38.2856 33.1424 38.1756 33.2306 38.0509 33.2935C37.9263 33.3563 37.7899 33.3924 37.6505 33.3994C37.5111 33.4064 37.3718 33.3841 37.2415 33.334C37.1112 33.2838 36.9929 33.207 36.8941 33.1084L31.7201 27.9344L24.4081 37.9884C24.2481 38.1918 24.0156 38.3253 23.7593 38.3608C23.503 38.3963 23.2429 38.331 23.0336 38.1788C22.8244 38.0265 22.6824 37.7991 22.6373 37.5443C22.5923 37.2895 22.6478 37.0271 22.7921 36.8124L30.7921 25.8124C30.877 25.6954 30.9863 25.5982 31.1124 25.5276C31.2384 25.4569 31.3783 25.4144 31.5224 25.403C31.6665 25.3916 31.8114 25.4115 31.947 25.4615C32.0826 25.5115 32.2058 25.5902 32.3081 25.6924L37.5261 30.9124L44.4901 22.4004H38.6001C38.3349 22.4004 38.0805 22.295 37.893 22.1075C37.7055 21.92 37.6001 21.6656 37.6001 21.4004Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/graph.b1981a41.svg";
export { ForwardRef as ReactComponent };